import FeeModelCards from "components/FeeModelCards";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { FeeModelCardsAdapterProps } from "./FeeModelCards.d";

const FeeModelCardsAdapter = ({
  blok: { content = [], infoBoxText },
  sbEditable,
}: ReactStoryblokComponent<FeeModelCardsAdapterProps>) => (
  <FeeModelCards content={content} infoBoxText={infoBoxText} sbEditable={sbEditable} />
);
export default FeeModelCardsAdapter;
